export default function DownloadCTA() {
  return (
    <section
      id="download"
      className="relative w-full min-h-[480px] md:min-h-[560px] flex items-center justify-center overflow-hidden"
      aria-label="下载51app"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20smartphone%20app%20download%20scene%20with%20soft%20golden%20hour%20lighting%2C%20dramatic%20dark%20background%20with%20warm%20orange%20glow%2C%20mobile%20phone%20floating%20with%20glowing%20screen%2C%20editorial%20product%20photography%20style&width=1600&height=700&seq=download-bg&orientation=landscape"
        alt="下载51app"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 text-center px-4 md:px-8">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 tracking-wide uppercase">
          立即下载 51app
        </h2>
        <p className="mt-4 md:mt-5 text-base md:text-lg text-background-100 max-w-xl mx-auto leading-relaxed">
          全网吃瓜爆料，免费下载安装
          <br />
          最新版本，实时更新今日最热八卦
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <button
            type="button"
            className="inline-flex items-center gap-3 px-6 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <span className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center -ml-1">
              <i className="ri-apple-fill w-4 h-4 flex items-center justify-center" />
            </span>
            iPhone 下载
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
          </button>
          <button
            type="button"
            className="inline-flex items-center gap-3 px-6 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <span className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center -ml-1">
              <i className="ri-android-fill w-4 h-4 flex items-center justify-center" />
            </span>
            Android 下载
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
          </button>
        </div>
        <p className="mt-4 text-xs text-background-200/70">
          完全免费 · 无需注册 · 即装即用
        </p>
      </div>
    </section>
  );
}